import api from './client';
import type { BIDashboard, BIWidget } from '../types/bi';

export type { BIDashboard, BIWidget };

export const getDashboards = () => api.get('/bi/dashboards');
export const getDashboard = (id: string) => api.get(`/bi/dashboards/${id}`);
export const createDashboard = (data: any) => api.post('/bi/dashboards', data);
export const updateDashboard = (id: string, data: any) => api.put(`/bi/dashboards/${id}`, data);
export const deleteDashboard = (id: string) => api.delete(`/bi/dashboards/${id}`);